import { SUBSCRIPTION } from "~/lib/constants";

interface PlanFeature {
  key: string;
  label: React.ReactNode;
}

interface PlanFeatureListProps {
  planType: "free" | "paid";
  variant?: "compact" | "detailed";
  iconColor?: string;
}

/**
 * プランの機能定義を取得
 */
function getPlanFeatures(planType: "free" | "paid"): PlanFeature[] {
  const plan = planType === "free" ? SUBSCRIPTION.PLANS.FREE : SUBSCRIPTION.PLANS.PAID;

  if (planType === "free") {
    return [
      {
        key: "raindrops",
        label: (
          <>
            Up to <strong>{plan.MAX_RAINDROPS_PER_DEW} raindrops</strong> per daily Dew
          </>
        ),
      },
      {
        key: "history",
        label: (
          <>
            Access to <strong>latest {plan.MAX_DEWS_HISTORY} Dews</strong> history
          </>
        ),
      },
      {
        key: "exclusion",
        label: (
          <>
            Up to <strong>{plan.MAX_EXCLUDED_COLLECTIONS} collection exclusion</strong>
          </>
        ),
      },
      {
        key: "email",
        label: "Daily email notifications",
      },
      {
        key: "integration",
        label: "Secure Raindrop.io integration",
      },
    ];
  } else {
    return [
      {
        key: "raindrops",
        label: (
          <>
            Up to <strong>{plan.MAX_RAINDROPS_PER_DEW} raindrops</strong> per daily Dew
          </>
        ),
      },
      {
        key: "history",
        label: (
          <>
            Access to <strong>latest {plan.MAX_DEWS_HISTORY} Dews</strong> history
          </>
        ),
      },
      {
        key: "exclusion",
        label: (
          <>
            <strong>Unlimited collection exclusions</strong>
          </>
        ),
      },
      {
        key: "notification-time",
        label: "Customizable email notification time",
      },
      {
        key: "all-features",
        label: "All Free plan features",
      },
    ];
  }
}

/**
 * プランの機能リストを表示するコンポーネント
 */
export function PlanFeatureList({
  planType,
  iconColor,
}: PlanFeatureListProps) {
  const features = getPlanFeatures(planType);
  const defaultIconColor = planType === "free" ? "text-green-500" : "text-purple-500";
  const color = iconColor || defaultIconColor;

  return (
    <ul className="space-y-3">
      {features.map((feature) => (
        <li key={feature.key} className="flex items-start">
          <span className={`${color} mr-3 mt-0.5`}>✓</span>
          <span>{feature.label}</span>
        </li>
      ))}
    </ul>
  );
}
